
import { ref } from 'vue'
import { defineStore } from 'pinia'

const localStoragePrefix = location.hostname;
let userInfoData = localStorage.getItem(`${localStoragePrefix}_artmisAdsUserInfo`);
if (userInfoData) {
  userInfoData = JSON.parse(userInfoData);
}

export const useUserInfoStore = defineStore('artmisAdsUserInfo', () => {
  const userLoading = ref(false);
  const userInfo = ref(userInfoData);
  function setUserInfo(data, userToken, menus) {

    if (data) {
      userInfo.value = data;
      if (menus) {
        userInfo.value.menus = menus;
      }
      localStorage.setItem(`${localStoragePrefix}_artmisAdsUserInfo`, JSON.stringify(userInfo.value));
    } else {
      userInfo.value = null;
      localStorage.setItem(`${localStoragePrefix}_artmisAdsUserInfo`, '');
      localStorage.setItem(`${localStoragePrefix}_userToken`, '')
      localStorage.setItem(`${localStoragePrefix}_tokenTime`, '');
    }
    if (userToken) {
      const time = new Date().getTime();
      localStorage.setItem(`${localStoragePrefix}_userToken`, userToken);
      localStorage.setItem(`${localStoragePrefix}_tokenTime`, time);
    }
  }

  function setUserLoading(status) {
    userLoading.value = status;
  }

  return { userInfo, setUserInfo, userLoading, setUserLoading };
})
